import React, {Component, createRef, useRef} from 'react'
import './Banner.css'
import bannerpic from './pics/event.svg'
import { getBanner, getRegisterLink } from "../../../fetcher";
export default class Banner extends Component {
    constructor(props){
        super(props)
        this.state = { 
            bannerLists:[],
            TechNum: 0,
            DirectorsNum: 0,
            EventsNum: 0,
            link:'https://luma.com/xcyg55m0'
        }
        this.listRefs = [];
        this.listRefs = Array.from({ length: 5 }, (_, i) => this.listRefs[i] ?? React.createRef());
    }
    componentDidMount() {
        let timer = setInterval(() => {
          this.state.TechNum = this.state.TechNum + 10
          this.state.DirectorsNum = this.state.DirectorsNum + 2
          this.state.EventsNum = this.state.EventsNum + 1
          this.forceUpdate()
          if (this.state.TechNum == 1000) {
            this.state.TechNum = '1000'
            this.state.DirectorsNum = '250'
            clearInterval(timer)
            this.forceUpdate()
          }
        }, 10)
    }
      
    fetchBannerData = async () => {
        try {
          const bannerData = await getBanner();
          let bannerList = [];
      
          bannerData.records?.forEach((bannerContentElement, index) => {
            const banner = bannerData.records[index].fields;
            let id = index;
            let name = banner.Name;
            let photo = bannerpic
            if(banner.Photo){
                photo = banner.Photo[0].url
            }
            let bannerDetail = { id: id, name:name, photo: photo };
            console.log(bannerDetail)
            bannerList.push(bannerDetail);
          });
      
          this.setState({ bannerLists: bannerList });
        } catch (error) {
          console.error(error);
        }
    };

    fetchLinkData = async () => {
        try {
          const linkData = await getRegisterLink;
        
          linkData.records.forEach((speakerContentElement, index) => {
            const ylink = linkData.records[0].fields;
            
            this.setState({link:ylink.Link})
          });

        } catch (error) {
          console.error(error);
        }
      };

      

    state = {
        tech:1000,
        jobs:250,
        events:100,
    }

    index = 2

    
    handleDot =()=>{
        this.listRefs.forEach((item, i) => {
            if (i === this.index) {
                item.current.classList.add('dotActive');
            } else {
                item.current.classList.remove('dotActive');
            }
        });
    }

    handleLeftClick =()=> {
        this.index = (this.index + 4) % 5
        this.carouselContent.style.left = (this.index * -100) + "%"

        this.handleDot()
    }

    handleRightClick =()=> {
        this.index = (this.index + 1) % 5
        this.carouselContent.style.left = (this.index * -100) + "%"

        this.handleDot()
    }

    handleRegisterClick = () =>{
        window.open(this.state.link, '_blank');  
    }

    componentDidMount() {
        this.fetchBannerData();
        window.addEventListener('resize', this.updateCarouselHeight);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateCarouselHeight);
    }

    handleImageLoad = () => {
        this.updateCarouselHeight();
    }      
    
    updateCarouselHeight = () => {
        const bannerImg = document.querySelector('.banner_img')
        const bannerButton = document.querySelector('.leftright-button-container')
        if(bannerImg)
        bannerButton.style.height = window.getComputedStyle(bannerImg).height
    }

    handleDotClick = (index) => {
        this.index = index;
        this.carouselContent.style.left = `${-index * 100}%`; 
        this.handleDot(); 
    };

    render() {
        let BannerList = this.state.bannerLists.map(item=>{
            return (
                <li className="about_carousel_content" key={item.id}>
                <img className = "banner_img" src={item.photo}  alt="pic" onLoad={this.handleImageLoad}/>
                </li>
            )
        })
        return (
            <div className = "header-container">
                 <div>
        <h1 className='header_title'>SILICON VALLEY<br/>LEADERSHIP COMMUNITY</h1>
        <h3 className='header_content'>Celebrate and Inspire Great Leadership</h3>

        {/* <iframe title='youtube_video' width="100%" height="758" src="https://www.youtube.com/embed/VIDEO_ID_HERE" frameborder="0" allowfullscreen></iframe> */}
      </div>

                <div className="about_carousel">
                    <ul ref={c => this.carouselContent = c} className="about_carousel_container">
                        {BannerList}
                    </ul>
                    {/*<ul className="b-about_carousel_dot_container">
                        <li  onClick={() => this.handleDotClick(0)} ref={c => this.one = c} className="b-about_carousel_dot"></li>
                        <li onClick={() => this.handleDotClick(1)} ref={c => this.two = c}  className="b-about_carousel_dot"></li>
                        <li onClick={() => this.handleDotClick(2)} ref={c => this.three = c}  className="b-about_carousel_dot"></li>
                        <li onClick={() => this.handleDotClick(3)} ref={c => this.four = c}  className="b-about_carousel_dot"></li>
                        <li onClick={() => this.handleDotClick(4)} ref={c => this.five = c}  className="b-about_carousel_dot"></li>
                    </ul>*/}
                    <div className="banner_carousel_dot_container">
                        <ul className="banner_carousel_dot_ul">
                            {this.listRefs.map((ref, i) => (
                              <li
                                onClick={() => this.handleDotClick(i)}
                                key={i}
                                ref={ref}
                                className={`banner_carousel_dot ${i === this.index ? 'dotActive' : ''}`}
                              ></li>
                            ))}
                        </ul>
                    </div>
                    <div className = "leftright-button-container">
                        <div onClick={() => this.handleLeftClick()} className="banner_button_left">
                            <img className="leftButton" alt="leftbtn" />
                        </div>
                        <div className="banner_button_buttom" onClick={()=>this.handleRegisterClick()}> Register</div>

                        <div onClick={() => this.handleRightClick()} className="banner_button_right">
                            <img className="rightButton" alt="leftbtn" />
                        </div>
                    </div>
                    <div className = "bnttom-button-container">
                        <div className="banner_button_buttom"> Register</div>
                    </div>
                </div>
            </div>
        )
  }
}
